import { useIntl } from "react-intl";
import { CellTags } from "src/app/components";
import { SimpleEntityGridColumn } from "src/app/components/grid/EntityGrid";
import { columnParForDates } from "src/app/components/grid/GridHelpers";
const useUrlsAnalyzedGridColumns = () => {
    const { formatMessage } = useIntl();

    const gridColumns: Array<SimpleEntityGridColumn> = [
        {
            field: "publishedAt",
            headerName: formatMessage({ id: "urls.grid.col.publishedAt" }),
            ...columnParForDates("publishedAt"),
            pinned: "left",
            minWidth: 90,
            maxWidth: 90,
        },
        {
            field: "url",
            headerName: formatMessage({ id: "urls.grid.col.url" }),
            filter: "agTextColumnFilter",
            pinned: "left",
        },
        {
            field: "pbn",
            headerName: formatMessage({ id: "urls.grid.col.pbn" }),
            filter: "agSetColumnFilter",
            minWidth: 80,
            maxWidth: 80,
        },

        {
            field: "thematic",
            headerName: formatMessage({ id: "urls.grid.col.thematic" }),
            filter: "agSetColumnFilter",
            minWidth: 80,
            maxWidth: 80,
        },
        {
            field: "writingType",
            headerName: formatMessage({ id: "urls.grid.col.writingType" }),
            valueGetter: ({ data }: any) =>
                formatMessage({
                    id: `content.grid.col.writingType.${data.writingType}`,
                }),
            filter: "agSetColumnFilter",
            minWidth: 80,
            maxWidth: 80,
        },
        {
            field: "keyword",
            headerName: formatMessage({
                id: "urls.grid.col.keyword",
            }),
            filter: "agTextColumnFilter",
            valueGetter: ({ data }: any) => data?.keyword,
            cellRenderer: ({ data }: any) => <CellTags tags={[data.keyword]} />,
            autoHeight: true,
        },
        {
            field: "position",
            headerName: formatMessage({
                id: "urls.grid.col.position",
            }),
            filter: "agNumberColumnFilter",
            cellClass: "number-cell",
            minWidth: 80,
            maxWidth: 80,
        },
        {
            field: "volume",
            headerName: formatMessage({
                id: "urls.grid.col.volume",
            }),
            filter: "agNumberColumnFilter",
            cellClass: "number-cell",
            minWidth: 80,
            maxWidth: 80,
        },
        {
            field: "kd",
            headerName: formatMessage({
                id: "urls.grid.col.kd",
            }),
            filter: "agNumberColumnFilter",
            cellClass: "number-cell",
            minWidth: 80,
            maxWidth: 80,
        },
        {
            field: "traffic",
            headerName: formatMessage({
                id: "urls.grid.col.traffic",
            }),
            filter: "agNumberColumnFilter",
            cellClass: "number-cell",
            minWidth: 80,
            maxWidth: 80,
        },
    ];

    return gridColumns;
};

export default useUrlsAnalyzedGridColumns;
